import type { MailboxInfo } from "owa-client-types";
import loadOutlookFavorites from "../utils/loadOutlookFavorites";

export default function loadFavorites(mailboxInfo: MailboxInfo): void {
    // Load roaming favorites from the Outlook Favorites
    loadOutlookFavorites(mailboxInfo);
}
